import { globalEntitlements } from '../utils/globalEntitlements';

export const BUSINESS_CREDIT_CARDS_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.businessCreditCards.buyBox.bulletPoint1' },
          { title: 'productPage.businessCreditCards.buyBox.bulletPoint2' },
          { title: 'productPage.businessCreditCards.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.businessCreditCards.buyBox.productName',
        interactService: {
          service: 'business_credit_cards',
          openInNewTab: true,
        },
        ctaIcon: {
          src: '/s2/material-icons/openinnewrounded.svg',
          alt: '',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/laptop-creditcard-business.png',
      alt: 'productPage.businessCreditCards.heroPicture.altText',
    },
    headline: 'productPage.businessCreditCards.page.headline',
    partnerLogo: {
      src: '/s2/vector/logo-chase-for-business.svg',
      alt: '',
    },
    partnerReviewBlanks: [],
    subheader: 'productPage.businessCreditCards.page.subheader',
  },
  benefit: {
    title: 'productPage.businessCreditCards.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/callsplitrounded.svg',
        title: 'productPage.businessCreditCards.valueProp.propTitle1',
        description: 'productPage.businessCreditCards.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/gppgoodrounded.svg',
        title: 'productPage.businessCreditCards.valueProp.propTitle2',
        description: 'productPage.businessCreditCards.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/cardgiftcardrounded.svg',
        title: 'productPage.businessCreditCards.valueProp.propTitle3',
        description: 'productPage.businessCreditCards.valueProp.shortCopy3',
      },
      {
        icon: '/s2/material-icons/creditscorerounded.svg',
        title: 'productPage.businessCreditCards.valueProp.propTitle4',
        description: 'productPage.businessCreditCards.valueProp.shortCopy4',
      },
      {
        icon: '/s2/material-icons/savingsrounded.svg',
        title: 'productPage.businessCreditCards.valueProp.propTitle5',
        description: 'productPage.businessCreditCards.valueProp.shortCopy5',
      },
      {
        icon: '/s2/material-icons/trendinguprounded.svg',
        title: 'productPage.businessCreditCards.valueProp.propTitle6',
        description: 'productPage.businessCreditCards.valueProp.shortCopy6',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/creditcardrounded.svg',
    title: 'productPage.businessCreditCards.topFeature.title',
    subheader: 'productPage.businessCreditCards.topFeature.subheader',
    image: '/s2/raster/smile-office-meeting.png',
    alt: 'productPage.businessCreditCards.topFeature.altText',
  },
  whatsIncluded: {
    title: 'productPage.businessCreditCards.whatsIncluded.title',
    items: [
      {
        title: 'productPage.businessCreditCards.whatsIncluded.item1',
        description: 'productPage.businessCreditCards.whatsIncluded.item1ShortDescription',
      },
      {
        title: 'productPage.businessCreditCards.whatsIncluded.item2',
        description: 'productPage.businessCreditCards.whatsIncluded.item2ShortDescription',
      },
      {
        title: 'productPage.businessCreditCards.whatsIncluded.item3',
        description: 'productPage.businessCreditCards.whatsIncluded.item3ShortDescription',
      },
    ],
    image: '/s2/raster/packages-storage-phone-card.png',
    alt: 'productPage.businessCreditCards.whatsIncluded.altText',
    hasDivider: true,
    hasNumber: false,
    hasMobileImage: false,
  },
  assistance: {
    title: 'productPage.businessCreditCards.needAssistance.title',
    getInTouch: 'productPage.businessCreditCards.needAssistance.getInTouch',
    actions: 'productPage.businessCreditCards.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.businessCreditCards.buyBox.buttonLabel',
  })
    .disable(null, 'productPage.businessCreditCards.buyBox.buttonDisabled.tooltip')
    .build(),
};
